
<transition name="page" mode="out-in">
  <component :is="layout"></component>
</transition>
